// AZM · CursorFX — velocity-stretched jelly crosshair, contextual labels, logo stamps on click

(function() {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var mark = document.querySelector('.cursor-fx');
  if (!mark) return;
  var jelly = mark.querySelector('.cursor-fx-jelly');
  var label = mark.querySelector('.cursor-fx-label');

  document.body.classList.add('cursor-fx-on');

  var tx = window.innerWidth / 2, ty = window.innerHeight / 2;
  var cx = tx, cy = ty, angle = 0, visible = false;

  function onMove(e) {
    tx = e.clientX; ty = e.clientY;
    if (!visible) { visible = true; mark.classList.add('on'); }
  }

  function onOver(e) {
    var t = e.target.closest && e.target.closest('[data-cursor],a,button,select,input,textarea,label,summary');
    if (t) {
      label.textContent = t.getAttribute('data-cursor') || (t.tagName === 'A' ? 'GO' : '');
      mark.classList.add('is-active');
      if (label.textContent) label.classList.add('show');
    } else {
      mark.classList.remove('is-active');
      label.classList.remove('show');
    }
  }

  function stamp(x, y) {
    var el = document.createElement('div');
    el.className = 'take-stamp';
    var img = document.createElement('img');
    img.src = window.azmStampUrl || '';
    img.alt = '';
    img.draggable = false;
    el.appendChild(img);
    el.style.left = x + 'px';
    el.style.top = y + 'px';
    el.style.setProperty('--rot', (Math.random() * 10 - 5).toFixed(1) + 'deg');
    document.body.appendChild(el);
    requestAnimationFrame(function() { el.classList.add('stamp-in'); });
    setTimeout(function() { el.classList.add('stamp-out'); }, 700);
    setTimeout(function() { el.remove(); }, 1000);
  }

  function onDown(e) {
    mark.classList.add('is-down');
    stamp(e.clientX, e.clientY);
  }

  function onUp() { mark.classList.remove('is-down'); }

  function onLeave() { visible = false; mark.classList.remove('on'); }

  function loop() {
    var dx = tx - cx, dy = ty - cy;
    cx += dx * 0.2; cy += dy * 0.2;
    var speed = Math.hypot(dx, dy);
    if (speed > 3) {
      var target = Math.atan2(dy, dx);
      var diff = target - angle;
      while (diff > Math.PI) diff -= Math.PI * 2;
      while (diff < -Math.PI) diff += Math.PI * 2;
      angle += diff * 0.25;
    }
    var stretch = 1 + Math.min(speed / 50, 1) * 0.9;
    mark.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
    if (jelly) {
      jelly.style.transform = 'rotate(' + angle + 'rad) scaleX(' + stretch.toFixed(3) + ') scaleY(' + (1 / stretch).toFixed(3) + ')';
    }
    requestAnimationFrame(loop);
  }

  window.addEventListener('mousemove', onMove, { passive: true });
  window.addEventListener('mouseover', onOver, { passive: true });
  window.addEventListener('mousedown', onDown);
  window.addEventListener('mouseup', onUp);
  document.documentElement.addEventListener('mouseleave', onLeave);
  requestAnimationFrame(loop);
})();
